import { Button } from '@repo/shadcn';
import { ColumnDef, Row } from '@tanstack/react-table';
import { FC } from 'react';
import { FaEdit } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { toast } from 'sonner';
import { z } from 'zod';

import { MODAL_ROUTE } from '@/constants';
import { useAppDispatch } from '@/features';
import { openModal } from '@/features/slice/event/event-slice';
import { SingleExpenseCategoryResponseSchema } from '@/features/slice/expense/expense.schema';
import { useDeleteExpenseCategoryMutation } from '@/features/slice/expense/expense-api-slice';

type ActionProps = {
    row: Row<z.infer<typeof SingleExpenseCategoryResponseSchema>>;
};
const Actions: FC<ActionProps> = ({ row }) => {
    const [deleteExpenseCategory] = useDeleteExpenseCategoryMutation();

    const dispatch = useAppDispatch();

    const handleUpdate = () => {
        dispatch(
            openModal({
                content: MODAL_ROUTE.CREATE_EXPENSE_CATEGORY,
                data: row.original,
            }),
        );
    };

    const handleDelete = async (id: string) => {
        try {
            await deleteExpenseCategory(id).unwrap();
            toast.success('Expense deleted successfully');
        } catch (error) {
            console.error('Failed to delete expense:', error);
            toast.error('Failed to delete expense');
        }
    };

    return (
        <div className="flex items-center justify-end gap-2">
            <Button
                className="group !p-1"
                type="button"
                variant={'link'}
                size="icon"
                onClick={() => {
                    handleUpdate();
                }}
            >
                <FaEdit className="h-5 w-5 text-gray-600 group-hover:text-gray-900" />
            </Button>
            <Button
                className="group  !p-1"
                type="button"
                variant={'link'}
                size="icon"
                onClick={() => {
                    handleDelete(row.original.id);
                }}
            >
                <TbTrash className="h-5 w-5 text-red-800 group-hover:text-red-500" />
            </Button>
        </div>
    );
};

export const expenseCategoryColumns: ColumnDef<
    z.infer<typeof SingleExpenseCategoryResponseSchema>
>[] = [
    {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => (
            <div className="font-medium ">{row.original.name || 'N/A'}</div>
        ),
    },

    // TODO: Implement edit and delete functionality
    {
        accessorKey: 'id',
        header: () => <div className="text-right">Actions</div>,
        cell: Actions,
    },
];
